var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFont = function SvgFont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222020",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2 22V2M22 22V2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7 18 3.653-10.514c.292-.673.835-1.49 1.294-1.486.68.005 1.036.708 1.43 1.486C13.772 8.266 17 18 17 18m-7.987-5.009 5.882-.062"
  })));
};
export default SvgFont;